import styled from "styled-components";

export const Base = styled.div(({ theme }) => ({
  padding: theme.spacing[20],
  width: "100%",
}));
